import { render, staticRenderFns } from "./my-upload3.vue?vue&type=template&id=4a5d4c1a&scoped=true"
import script from "./my-upload3.vue?vue&type=script&lang=js"
export * from "./my-upload3.vue?vue&type=script&lang=js"
import style0 from "./my-upload3.vue?vue&type=style&index=0&id=4a5d4c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d4c1a",
  null
  
)

export default component.exports